import { createContext, type MutableRefObject } from "react";

export type NavigationHoverContextValue = {
  hoveredElement: HTMLDivElement | null;
  previousHoveredElement: HTMLDivElement | null;
  panelRef: MutableRefObject<HTMLDivElement | null>;
  setHoveredElement: (_: NavigationHoverContextValue["hoveredElement"]) => void;
  panelNode: HTMLElement | null;
};

export const NavigationHoverContext = createContext<
  NavigationHoverContextValue | undefined
>(undefined);
